import { render, staticRenderFns } from "./TopAlertBar.vue?vue&type=template&id=472d5942&scoped=true&"
import script from "./TopAlertBar.vue?vue&type=script&lang=js&"
export * from "./TopAlertBar.vue?vue&type=script&lang=js&"
import style0 from "./TopAlertBar.vue?vue&type=style&index=0&id=472d5942&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d5942",
  null
  
)

export default component.exports